import source from '../../../../../docs/legal/datenschutzerklaerung-team.md?raw';
import { LEGAL_PLACEHOLDER } from '@/features/guest';

/**
 * Datenschutzerklärung der Team-Anmeldung, aus `docs/legal/` eingebunden wie die des Gastportals:
 * eine Datei, und sie ist die, die angezeigt wird. Der Link erscheint erst ohne Platzhalter.
 */
export const TEAM_PRIVACY = source;

export const teamPrivacyPublishable = !LEGAL_PLACEHOLDER.test(source);
